<gt-header></gt-header>
<ion-content>
  <div>
    <div class="flex items-center justify-between">
      <ion-icon class="text-size-32" name="gt-back" (click)="navController.back()"></ion-icon>
      <div class="uppercase font-semibold text-lg">{{'ONBOARDING.REGISTER.PAYMENT.EXTRAS_TITLE' | transloco}}</div>
      <div class="w-8"></div>
    </div>
    @if(extraServices$ | async; as extraServices) {
    <gt-inscriptions-payments
      [inscription]="extraServices[0].inscription"
      [edition]="extraServices[0].edition"
      [payments]="(myCurrentPayments$ | async) || []"></gt-inscriptions-payments>
    }
    <div>
      <div class="py-4 flex flex-col gap-3">
        <div
          class="border rounded border-secondary flex flex-col gap-2 p-2"
          *ngFor="let extraService of extraServices$ | async; let index = index">
          <div class="text-destacadoM extra-service-title">{{extraService.name}}</div>
          <div class="text-sm">{{ extraService.description }}</div>
          <div *ngIf="!extraService.payOffline" class="flex justify-center gap-8 items-center">
            <gt-button
              (click)="services[index].quantity = services[index].quantity ? services[index].quantity - 1 : 0; reCalcRate(extraService, false)"
              [disabled]="!services[index].quantity || services[index].quantity === 0"
              [onlyIcon]="'onlyIcon'"
              class="controls-buttons"
              ><ion-icon name="gt-minus"></ion-icon
            ></gt-button>
            <div class="text-counter">
              {{services[index].quantity}}
              <span *ngIf="extraService.mandatory && extraService.byPerson"> / {{ extraService.neededQuantity }}</span>
            </div>
            <gt-button
              (click)="services[index].quantity = services[index].quantity ? services[index].quantity + 1 : 1; reCalcRate(extraService)"
              [disabled]="(extraService.byPerson && services[index].quantity === extraService.neededQuantity) || (!extraService.byPerson && extraService.maxQuantity === services[index].quantity)"
              [onlyIcon]="'onlyIcon'"
              class="controls-buttons"
              ><ion-icon name="gt-plus"></ion-icon
            ></gt-button>
          </div>
          <hr class="m-2" />
          <div class="uppercase font-extrabold text-lg text-black tracking-widest flex justify-center gap-2">
            {{extraService.price}} €
            <span *ngIf="extraService.byPerson" class="uppercase font-extrabold text-lg text-black tracking-widest"
              >{{'ONBOARDING.REGISTER.PAYMENT.BY_PERSON' | transloco}}</span
            >
          </div>
          <div class="flex flex-col items-center">
            <div *ngIf="extraService.mandatory" class="text-danger uppercase font-semibold">
              {{'ONBOARDING.REGISTER.PAYMENT.MANDATORY' | transloco}}
            </div>
            <small class="text-center">
              {{ (extraService.payOffline ? 'ONBOARDING.REGISTER.PAYMENT.MANDATORY_PAYMENT_OFFLINE_DESC' :
              'ONBOARDING.REGISTER.PAYMENT.MANDATORY_DESC') | transloco }}
            </small>
          </div>
        </div>
      </div>
      <h3 class="mt-4">{{'ONBOARDING.REGISTER.PAYMENT.PAYMENT_METHOD_TITLE' | transloco}}</h3>
      <div class="flex gap-3 justify-center">
        <gt-button
          (click)="paymentMethod = 'REDSYS'"
          class="payment-method-button flex-1 ![--height:112px]"
          iconPosition="top"
          [color]="null"
          [expand]="'max'"
          [ngClass]="{'payment-method-button-activated': paymentMethod === 'REDSYS' }">
          <ion-icon name="card-outline" class="text-4xl"></ion-icon>
          {{'ONBOARDING.REGISTER.PAYMENT.PAYMENT_METHOD_CARD' | transloco}}
        </gt-button>
        <gt-button
          (click)="paymentMethod = 'BANK'"
          class="payment-method-button flex-1 ![--height:112px]"
          [color]="null"
          [expand]="'max'"
          iconPosition="top"
          [ngClass]="{'payment-method-button-activated': paymentMethod === 'BANK' }">
          <ion-icon name="gt-bank" class="text-4xl"></ion-icon>
          {{'ONBOARDING.REGISTER.PAYMENT.PAYMENT_METHOD_BANK' | transloco}}
        </gt-button>
      </div>
    </div>
    <div class="w-full bg-secondary fixed bottom-0 left-0 z-50 custom-shadow px-6 pt-2 pb-8">
      <div class="h-full max-w-lg mx-auto flex items-center justify-between">
        <div class="flex flex-col">
          <div class="uppercase font-extrabold text-lg text-black tracking-widest">
            {{'ONBOARDING.REGISTER.PAYMENT.TOTAL' | transloco | uppercase}}
          </div>
          <div class="uppercase font-extrabold text-2xl text-black">{{total}} €</div>
        </div>
        <gt-button [disabled]="!paymentMethod || loading || total === 0" (click)="confirm()">
          {{'ONBOARDING.REGISTER.PAYMENT.PAY' | transloco}}
        </gt-button>
      </div>
    </div>
  </div>
</ion-content>
